import { render, staticRenderFns } from "./IntegrationsOverview.vue?vue&type=template&id=0a2293c0&lang=pug&"
import script from "./IntegrationsOverview.vue?vue&type=script&lang=js&"
export * from "./IntegrationsOverview.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsOverview.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports